import React from 'react';

import * as css from './css/decoration';

function Decoration(props) {
  const { className } = props;

  return (
    <css.Decoration className={className}>
      <css.Floor className='floor-1'>
        <img src={require('./img/floor-1-left.png')} alt='' className='left' />
        <img
          src={require('./img/floor-1-right.png')}
          alt=''
          className='right'
        />
      </css.Floor>
      <css.Floor className='floor-2'>
        <img src={require('./img/floor-2-left.png')} alt='' className='left' />
        <img
          src={require('./img/floor-2-right.png')}
          alt=''
          className='right'
        />
      </css.Floor>
      <css.Floor className='floor-3'>
        <img src={require('./img/floor-3-left.png')} alt='' className='left' />
        <img
          src={require('./img/floor-3-right.png')}
          alt=''
          className='right'
        />
      </css.Floor>
      <css.Floor className='floor-4'>
        <img src={require('./img/floor-4-left.png')} alt='' className='left' />
        <img
          src={require('./img/floor-4-right.png')}
          alt=''
          className='right'
        />
      </css.Floor>
    </css.Decoration>
  );
}

export default Decoration;
